import { render } from "./App.vue?vue&type=template&id=5e8c2a9e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5e8c2a9e&lang=scss"

import exportComponent from "/home/duke/code/duke-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__